var sentEntries = [];

var isValidHostname =
  window.location.hostname.indexOf('cian.ru') >= 0 &&
  window.location.hostname.indexOf('local.cian.ru') < 0 &&
  window.location.hostname.indexOf('dev.cian.ru') < 0 &&
  window.location.hostname.indexOf('stage.cian.ru') < 0;
var forceMetrics = window.location.hash.indexOf('force-metrics') >= 0;

function isGoodEntry(entry) {
  return entry && (
    (window.PerformanceMeasure && entry instanceof window.PerformanceMeasure) ||
    entry.entryType === 'measure'
  );
}

function entryHash(entry) {
  return [
    entry.connectEnd,
    entry.connectStart,
    entry.decodedBodySize,
    entry.domainLookupEnd,
    entry.domainLookupStart,
    entry.duration,
    entry.encodedBodySize,
    entry.entryType,
    entry.fetchStart,
    entry.initiatorType,
    entry.name,
    entry.redirectEnd,
    entry.redirectStart,
    entry.requestStart,
    entry.responseEnd,
    entry.responseStart,
    entry.secureConnectionStart,
    entry.startTime,
    entry.transferSize,
    entry.workerStart,
  ].join(':');
}

function isEntryNotSent(entry) {
  return sentEntries.indexOf(entryHash(entry)) === -1;
}

function markEntryAsSent(entry) {
  sentEntries.push(entryHash(entry));
}

function getClientTime() {
  return window.performance
    ? window.performance.timing.fetchStart
    : window.__cianMetrics__.loadingTime;
}

function get(obj, key) {
  var res = obj[key];
  if (res === undefined) {
    return null;
  }
  return res;
}

function collectNavigatorData() {
  return {
    cookieEnabled: get(navigator, 'cookieEnabled'),
    hardwareConcurrency: get(navigator, 'hardwareConcurrency'),
    platform: get(navigator, 'platform'),
    userAgent: get(navigator, 'userAgent'),
    vendor: get(navigator, 'vendor'),
  };
}

function collectScreenData() {
  return {
    width: get(screen, 'width'),
    height: get(screen, 'height'),
    orientationType: screen.orientation ? get(screen.orientation, 'type') : null,
    colorDepth: get(screen, 'colorDepth'),
  };
}

function normalizePerformanceTiming(obj, calculateRelative) {
  var fetchStart = get(obj, 'fetchStart');

  function getTiming(key) {
    if (!(key in obj) || obj[key] === 0) {
      return null;
    }

    if (calculateRelative) {
      if (fetchStart === null || fetchStart === 0) {
        return null;
      }

      return obj[key] - fetchStart;
    } else {
      return obj[key];
    }
  }

  return {
    connectEnd: getTiming('connectEnd'),
    connectStart: getTiming('connectStart'),
    domainLookupEnd: getTiming('domainLookupEnd'),
    domainLookupStart: getTiming('domainLookupStart'),
    domComplete: getTiming('domComplete'),
    domContentLoadedEventEnd: getTiming('domContentLoadedEventEnd'),
    domContentLoadedEventStart: getTiming('domContentLoadedEventStart'),
    domInteractive: getTiming('domInteractive'),
    domLoading: getTiming('domLoading'),
    loadEventEnd: getTiming('loadEventEnd'),
    loadEventStart: getTiming('loadEventStart'),
    navigationStart: getTiming('navigationStart'),
    fetchStart: (fetchStart > 0) ? (calculateRelative ? 0 : fetchStart) : null,
    redirectEnd: getTiming('redirectEnd'),
    redirectStart: getTiming('redirectStart'),
    requestStart: getTiming('requestStart'),
    responseEnd: getTiming('responseEnd'),
    responseStart: getTiming('responseStart'),
    secureConnectionStart: getTiming('secureConnectionStart'),
    unloadEventEnd: getTiming('unloadEventEnd'),
    unloadEventStart: getTiming('unloadEventStart'),
  };
}

function normalizePerformanceNavigation(obj) {
  return {
    redirectCount: get(obj, 'redirectCount'),
    type: get(obj, 'type'),
  };
}

function normalizePerformanceEntry(obj) {
  return {
    connectEnd: get(obj, 'connectEnd'),
    connectStart: get(obj, 'connectStart'),
    decodedBodySize: get(obj, 'decodedBodySize'),
    domainLookupEnd: get(obj, 'domainLookupEnd'),
    domainLookupStart: get(obj, 'domainLookupStart'),
    duration: get(obj, 'duration'),
    encodedBodySize: get(obj, 'encodedBodySize'),
    entryType: get(obj, 'entryType'),
    fetchStart: get(obj, 'fetchStart'),
    initiatorType: get(obj, 'initiatorType'),
    name: get(obj, 'name'),
    redirectEnd: get(obj, 'redirectEnd'),
    redirectStart: get(obj, 'redirectStart'),
    requestStart: get(obj, 'requestStart'),
    responseEnd: get(obj, 'responseEnd'),
    responseStart: get(obj, 'responseStart'),
    secureConnectionStart: get(obj, 'secureConnectionStart'),
    startTime: get(obj, 'startTime'),
    transferSize: get(obj, 'transferSize'),
    workerStart: get(obj, 'workerStart'),
  };
}

function getEmptyPerformanceData() {
  return {
    timing: normalizePerformanceTiming({}),
    absoluteTiming: normalizePerformanceTiming({}),
    customTiming: getCustomTiming({}),
    entryByDomain: getDomainsStatistics([]),
    navigation: normalizePerformanceNavigation({}),
    entries: [],
  };
}

function getCustomTiming(obj) {
  function getTimingDifference(first, second) {
    if ((first !== null) && (second !== null)) {
      return (first - second);
    } else {
      return null;
    }
  }

  return {
    domainLookup: getTimingDifference(get(obj, 'domainLookupEnd'), get(obj, 'domainLookupStart')),
    backend: getTimingDifference(get(obj, 'responseStart'), get(obj, 'requestStart')),
    domInteractive: getTimingDifference(get(obj, 'domInteractive'), get(obj, 'domLoading')),
    domContentLoaded: getTimingDifference(get(obj, 'domContentLoadedEventStart'), get(obj, 'domLoading')),
    domComplete: getTimingDifference(get(obj, 'domComplete'), get(obj, 'domLoading')),
    load: getTimingDifference(get(obj, 'loadEventStart'), get(obj, 'domLoading')),
  };
}

function extractDomain(url) {
  var domain = url;
  var index;

  index = domain.indexOf('://');
  if (index >= 0) {
      domain = domain.slice(index + 3);
  }

  index = domain.indexOf('/');
  if (index >= 0) {
      domain = domain.slice(0, index);
  }

  index = domain.indexOf(':');
  if (index >= 0) {
      domain = domain.slice(0, index);
  }

  var domainParts = domain.split('.');

  if (domainParts[domainParts.length - 2] !== 'cian' || domainParts[domainParts.length - 1] !== 'site') {
    domainParts = domainParts.slice(-2);
  }

  domain = domainParts.join('.').replace(/[^a-z]+/g, '_');

  return domain;
}

function getMinMaxAvg(durations) {
  if (durations.length === 0) {
    return {
      min: 0,
      max: 0,
      avg: 0,
      count: 0
    };
  }

  return {
    min: Math.min.apply(null, durations),
    max: Math.max.apply(null, durations),
    avg: durations.reduce(function(a, b) { return a + b; }) / durations.length,
    count: durations.length
  };
}

function getDomainsStatistics() {
  // Legacy
  return {min: {}, max: {}, avg: {}, count: {}};
}

function collectPerformanceData() {
  if (!window.performance) {
    return getEmptyPerformanceData();
  }

  var timing = normalizePerformanceTiming(performance.timing || {}, true);
  var absoluteTiming = normalizePerformanceTiming(performance.timing || {}, false);
  var customTiming = getCustomTiming(performance.timing);
  var entryByDomain = getDomainsStatistics(performance.getEntries ? performance.getEntries() : []);
  var navigation = normalizePerformanceNavigation(performance.navigation || {});
  var entries = (performance.getEntries ? performance.getEntries() : [])
    .filter(isGoodEntry);

  entries.forEach(markEntryAsSent);

  return {
    timing: timing,
    absoluteTiming: absoluteTiming,
    customTiming: customTiming,
    entryByDomain: entryByDomain,
    navigation: navigation,
    entries: entries.map(normalizePerformanceEntry),
  };
}

function runAddMetricsWithInterval(apiUrl, profileSessionKey) {
  if (window.performance === 'undefined') {
    return;
  }

  if (profileSessionKey) {
    profileSessionKey = /\/$/.test(profileSessionKey)
      ? profileSessionKey
      : profileSessionKey + '/';
  } else {
    profileSessionKey = 'no-profile-session-key/';
  }

  var apiUrlWithSessionKey = /\/$/.test(apiUrl)
    ? apiUrl + profileSessionKey
    : apiUrl + '/' + profileSessionKey;

  var entries = (performance.getEntries ? performance.getEntries() : [])
    .filter(isGoodEntry)
    .filter(isEntryNotSent);

  if (entries.length > 0) {
    entries.forEach(markEntryAsSent);
    sendMetrics(apiUrlWithSessionKey, entries.map(normalizePerformanceEntry));
  }

  setTimeout(function() {
    runAddMetricsWithInterval(apiUrl, profileSessionKey);
  }, 10000);
}

function collectFirstPaint(domLoading) {
  var firstPaint = undefined;
  var firstPaintTime = undefined;

  if (window.chrome && window.chrome.loadTimes) {
    firstPaint = window.chrome.loadTimes().firstPaintTime * 1000;
  } else if (window.performance && window.performance.timing && typeof window.performance.timing.msFirstPaint === 'number') {
    firstPaint = window.performance.timing.msFirstPaint;
  }

  if (firstPaint === 0) {
    firstPaint = undefined;
  }

  if (domLoading != null && firstPaint != null) {
    firstPaintTime = firstPaint - domLoading;
  }

  return {
    firstPaint: firstPaint,
    firstPaintTime: firstPaintTime,
  };
}

function collectData(profileSessionKey, websiteType, pageType) {
  var performance = collectPerformanceData();
  var firstPaint = collectFirstPaint(performance.absoluteTiming.domLoading);
  var appRenders = window.__cianMetrics__.appRenders;
  appRenders.firstPaint = firstPaint.firstPaint;
  appRenders.firstPaintTime = firstPaint.firstPaintTime;

  return {
    url: location.href,
    profileSessionKey: profileSessionKey,
    clientTime: getClientTime(),
    appRenders: appRenders,
    versions: window.__cianMetrics__.versions,
    navigator: collectNavigatorData(),
    screen: collectScreenData(),
    performance: performance,
    websiteType: websiteType,
    pageType: pageType,
  };
}

function sendMetrics(apiUrl, data) {
  var xhr = new XMLHttpRequest();
  xhr.open('POST', apiUrl, true);
  xhr.withCredentials = true;
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.send(JSON.stringify(data));
}

function runMetricsCollector(apiUrl, profileSessionKey, websiteType, pageType) {
  setTimeout(function() {
    sendMetrics(apiUrl, collectData(profileSessionKey, websiteType, pageType));
  }, 1000);

  setTimeout(function() {
    runAddMetricsWithInterval(apiUrl, profileSessionKey);
  }, 10000);
}

function initializeMetrics() {
  if (!isValidHostname && !forceMetrics) {
    return;
  }

  var currentScript = document.currentScript || document.querySelector('[data-metrics-api]');

  if (!currentScript) {
    throw new Error();
  }

  var apiUrl = currentScript.getAttribute('data-metrics-api');
  var profileSessionKey = currentScript.getAttribute('data-profile-session-key') || '';

  var websiteType = currentScript.getAttribute('data-website-type') || 'Unknown';
  var pageType = currentScript.getAttribute('data-page-type') || 'Unknown';

  if (!apiUrl) {
    return;
  }

  window.__cianMetrics__ = window.__cianMetrics__ || {};
  window.__cianMetrics__.appRenders = window.__cianMetrics__.appRenders || {};
  window.__cianMetrics__.versions = window.__cianMetrics__.versions || {};
  window.__cianMetrics__.loadingTime = Date.now();

  if (document.readyState === 'complete') {
    runMetricsCollector(apiUrl, profileSessionKey, websiteType, pageType);
  } else {
    window.addEventListener('load', runMetricsCollector.bind(null, apiUrl, profileSessionKey, websiteType, pageType));
  }
}

initializeMetrics();



//////////////////
// WEBPACK FOOTER
// ./src/metrics.js
// module id = 0
// module chunks = 0